import { useAppSelector } from "@/store/hooks";
import { selectRegions } from "@/store/region/selectors";

import { BaseMap } from "./BaseMap";
import { BaseRegion } from "./BaseRegion";
import { Estonia } from "./Estonia";
import { Finland } from "./Finland";
import { Latvia } from "./Latvia";
import { Lithuania } from "./Lithuania";

type MapProps = {
  onHover: (region: string | undefined) => void;
  selectedRegion: string | undefined;
};

export const Map = ({ onHover, selectedRegion }: MapProps) => {
  const regions = useAppSelector(selectRegions);

  const getURLForRegion = (prefix: string): string | undefined =>
    regions?.find((region) => region.domainName.includes(prefix))?.domainName;

  const onRegionHoverChange = (value: boolean, region: string) => {
    onHover(value ? region : undefined);
  };

  return (
    <BaseMap>
      <BaseRegion
        isSelected={selectedRegion === "Estonia"}
        onHover={(value) => onRegionHoverChange(value, "Estonia")}
        url={getURLForRegion("ee")}
      >
        <Estonia />
      </BaseRegion>

      <BaseRegion
        isSelected={selectedRegion === "Latvia"}
        onHover={(value) => onRegionHoverChange(value, "Latvia")}
        url={getURLForRegion("lv")}
      >
        <Latvia />
      </BaseRegion>

      <BaseRegion
        isSelected={selectedRegion === "Lithuania"}
        onHover={(value) => onRegionHoverChange(value, "Lithuania")}
        url={getURLForRegion("lt")}
      >
        <Lithuania />
      </BaseRegion>

      <BaseRegion
        isSelected={selectedRegion === "Finland"}
        onHover={(value) => onRegionHoverChange(value, "Finland")}
        url={getURLForRegion("fi")}
      >
        <Finland />
      </BaseRegion>
    </BaseMap>
  );
};
